export enum ContainerSize {
  TABLET = 'tablet',
  DESKTOP_SMALL = 'desktop-small',
  DESKTOP_LARGE = 'desktop-large',
  DESKTOP_XLARGE = 'desktop-xlarge',
  DESKTOP_XXLARGE = 'desktop-xxlarge',
  FLUID = 'fluid',
}
